export enum ReturnsRoutePathsEnum {
  RETURN = 'returns/:returnCaseId',
  RETURNS = 'returns',
}
